export default __webpack_public_path__ + "static/media/apple-headphone.5098486e.png";